export const BlockTypes = {
  // Text blocks
  PARAGRAPH: 'paragraph',
  HEADING: 'heading',
  CAPTION: 'caption',

  // Formatting blocks
  BLOCKQUOTE: 'blockquote',
  CODE_BLOCK: 'codeBlock',
  HORIZONTAL_RULE: 'horizontalRule',

  // List blocks
  BULLET_LIST: 'bulletList',
  ORDERED_LIST: 'orderedList',
  LIST_ITEM: 'listItem',

  // Structure blocks
  TABLE: 'table',
  COLUMNS: 'columns',
  CALLOUT_BLOCK: 'calloutBlock',

  // Media blocks
  IMAGE: 'image',

  // Confidence blocks
  TAG: 'tag',
  HIGHLIGHT_BLOCK: 'highlightBlock',
  IMAGE_CARD: 'imageCard',
  METRIC_CARD: 'metricCard',
  VARIANT_CARD: 'variantCard',
  METRIC_TABLE: 'metricTable',
} as const;

export const textBlocks = [
  BlockTypes.PARAGRAPH,
  BlockTypes.HEADING,
  BlockTypes.CAPTION,
] as const;

export const formattingBlocks = [
  BlockTypes.BLOCKQUOTE,
  BlockTypes.CODE_BLOCK,
  BlockTypes.HORIZONTAL_RULE,
] as const;

export const listBlocks = [
  BlockTypes.BULLET_LIST,
  BlockTypes.ORDERED_LIST,
] as const;

export const structureBlocks = [
  BlockTypes.TABLE,
  BlockTypes.COLUMNS,
  BlockTypes.CALLOUT_BLOCK,
] as const;

export const mediaBlocks = [BlockTypes.IMAGE] as const;

export const confidenceBlocks = [
  BlockTypes.TAG,
  BlockTypes.HIGHLIGHT_BLOCK,
  BlockTypes.IMAGE_CARD,
  BlockTypes.METRIC_CARD,
  BlockTypes.VARIANT_CARD,
  BlockTypes.METRIC_TABLE,
] as const;

export const buildContentSchema = (
  blocks: readonly string[],
  quantifier: '+' | '*' = '+',
): string => `(${blocks.join(' | ')})${quantifier}`;

export const basicBlocks = [
  ...textBlocks,
  ...formattingBlocks,
  ...listBlocks,
  ...structureBlocks,
  ...mediaBlocks,
] as const;

export const allBlocks = [...basicBlocks, ...confidenceBlocks] as const;

export const BASIC_BLOCKS_CONTENT = buildContentSchema(basicBlocks);
export const ALL_BLOCKS_CONTENT = buildContentSchema(allBlocks);
export const CONFIDENCE_BLOCKS_CONTENT = buildContentSchema(confidenceBlocks);

export const cardContentBlocks = [
  BlockTypes.PARAGRAPH,
  BlockTypes.HEADING,
  BlockTypes.BLOCKQUOTE,
  BlockTypes.BULLET_LIST,
  BlockTypes.ORDERED_LIST,
  BlockTypes.IMAGE,
  BlockTypes.TAG,
  BlockTypes.HIGHLIGHT_BLOCK,
] as const;

export const CARD_CONTENT = buildContentSchema(cardContentBlocks);

// Helper to exclude specific blocks from a list
export const excludeBlocks = (
  blocks: readonly string[],
  exclude: readonly string[],
): string[] => blocks.filter(block => !exclude.includes(block));
